import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { QUERY_KEYS } from '../../config/constants';
import {
  forgotPasswordFn,
  getNotificationFn,
  getReportFieldsFn,
  getSideBarItemsFn,
  getUserFn,
  postChangePasswordFn,
  postResetPasswordFn,
} from '../../transactions/user/user';
import usePersonStore from '../../store/personStore';
import { downloadReportsFn } from '../../transactions/download/download';
import { getRolesAndAcess } from '../../utils/helper';
import { toast } from '../../components/ui/Toast/useToast';

const { USERS, SIDEBAR_ITEMS, REPORTS_FIELDS, NOTIFICATIONS } = QUERY_KEYS;

const useUserData = (accessToken, fetchData) => {
  const { setUserData, setRefreshSideBar, setShowGroupFleetAdminLandingPage } = usePersonStore();

  return useQuery({
    queryKey: [USERS],
    queryFn: getUserFn,
    enabled: !!accessToken && !!fetchData,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setRefreshSideBar(true);
      setUserData(data);
      localStorage.setItem('isAdmin', data.isAdmin);
      localStorage.setItem('isGroupFleetAdmin', data.isGroupFleetAdmin)
      if(data.isGroupFleetAdmin) {
        localStorage.setItem('companyGroup', data.companyGroup)
        setShowGroupFleetAdminLandingPage(true);
      }
    },
  });
};

// not using this function

export const useGetSideBarItemsFn = (accessToken, fetchSideBar) => {
  //
  const { setFetchCars } = usePersonStore();
  const showGroupFleetAdminLandingPage = usePersonStore(
      (store) => store.showGroupFleetAdminLandingPage
    );

  const {
    setUserRoles,
    setPageAccess,
    setShowRetailDashBoardType,
    setRefreshSideBar,
  } = usePersonStore();
  const navigate = useNavigate();
  return useQuery({
    queryKey: [SIDEBAR_ITEMS],
    queryFn: getSideBarItemsFn,
    enabled: !!accessToken && fetchSideBar,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const { userRoles, pageAccess } = getRolesAndAcess(data.data);
      setRefreshSideBar(false);

      setUserRoles(userRoles);
      setPageAccess(pageAccess);
      // If user is only fleet admin or Driver then check if the car count is less the 6
      if (showGroupFleetAdminLandingPage) {
        navigate('/groupfleetadmin');
      } else if (
        userRoles.length === 1 &&
        (userRoles.includes('fleetadmin') || userRoles.includes('driver'))
      ) {
        setFetchCars(true);
        // setEnableCar(true);
      } else {
        setShowRetailDashBoardType(false);

        navigate('/dashboard');
      }
    },
  });
};

export const usePostResetPassword = () => {
  return useMutation({
    mutationFn: ({ payload, resetCode }) =>
      postResetPasswordFn(payload, resetCode),
  });
};

export const usePostChangePassword = () => {
  return useMutation({
    mutationFn: (payload) => postChangePasswordFn(payload),
    onError: () => {
      toast({
        variant: 'destructive',
        description: 'Παρουσιάστηκε κάποιο πρόβλημα',
      });
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (payload) => forgotPasswordFn(payload),
    onError: () => {
      toast({
        variant: 'destructive',
        description: 'Παρουσιάστηκε κάποιο πρόβλημα',
      });
    },
  });
};

export const useGetReportFields = (accessToken, fetchData) => {
  return useQuery({
    queryKey: [REPORTS_FIELDS],
    queryFn: getReportFieldsFn,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

export const useDownloadReports = () => {
  return useMutation({
    mutationFn: (payload) => downloadReportsFn(payload),
  });
};

export const useGetNotifications = (isLoggedIn) => {
  return useQuery({
    queryKey: [NOTIFICATIONS],
    queryFn: getNotificationFn,
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!isLoggedIn,
    refetchOnWindowFocus: false,
  });
};

export default useUserData;
